/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import UpdateProfilePic from "./UpdateProfilePic";
import { commonServices } from "../../../api/services/commonServices";
import {
  setUserProfilePic,
  setis_FilePathset,
  setsignedprofilepic,
} from "../../../infra/aggregates/profilePicSlice";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "../../../infra/hooks";
function UpdateProfilePicController() {
  const { t } = useTranslation();
  const selectorpic = useAppSelector(
    (state) => state.profilePicSlice.profilePic
  );
  const trans = t;
  const [currentProfilePic, setCurrentProfilePic] = useState(selectorpic);
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state);

  function getNewProfilePic(data: any) {
    updateProfilePic(data);
  }

  async function updateProfilePic(pic: any) {
    const userId: any = selector.authSlice.user_id;
    const CompanyID: any = selector.authSlice.company_id;
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("profile_pic", pic);
    formData.append("CompanyID", CompanyID);
    await commonServices
      .updateProfilePic(formData)
      .then((response: any) => {
        if (response.response == "success") {
          dispatch(setUserProfilePic(response?.data?.profile_pic));

          toast.success(trans("Profile Picture Updated"));
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  }

  useEffect(() => {
    const user_id: any = selector.authSlice.user_id;
    const CompanyID: any = selector.authSlice.company_id;
    const Payload = {
      filepath: selectorpic,
      fullpath: true,
    };

    dispatch(setis_FilePathset(true));
    commonServices
      .getFilePath(CompanyID, user_id, Payload)
      .then((res: any) => {
        dispatch(setsignedprofilepic(res));
        dispatch(setis_FilePathset(false));

        setCurrentProfilePic(res);
      })
  }, [selectorpic]);

  return (
    <div>
      {/* <DTOUpdateProfilePic setProfilePic={getCurrentProfilePic} /> */}
      <UpdateProfilePic
        profilePic={currentProfilePic}
        setNewProfilePic={getNewProfilePic}
      />
    </div>
  );
}

export default UpdateProfilePicController;
